import { z } from "zod";

export const GetConfigRequestPathParamSchema = z.object({
  id: z.string(),
});

export type GetConfigRequestPathParamType = z.infer<
  typeof GetConfigRequestPathParamSchema
>;
